import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type GetRoomsForUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRoomsForUserQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomsForUser: { __typename?: 'RoomConnectionDto', edges: Array<{ __typename?: 'RoomEdgeDto', node: { __typename?: 'Room', id: string, membershipType: Types.MembershipType, slug: string, passcode?: string | null, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, cameraOff: boolean, owner?: { __typename?: 'RoomOwner', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null } | null } }> } } };

export type IsSlugUniqueQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type IsSlugUniqueQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isSlugUnique: boolean } };

export type IsSubSlugUniqueQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type IsSubSlugUniqueQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isSubSlugUnique: boolean } };

export type UpdateRoomMutationVariables = Types.Exact<{
  input: Types.RoomUpdateDto;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', id: string, membershipType: Types.MembershipType, slug: string, passcode?: string | null, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, cameraOff: boolean, ownerId?: string | null } };

export type IsValidPasscodeForRoomMutationVariables = Types.Exact<{
  input: Types.RoomPasscodeInput;
}>;


export type IsValidPasscodeForRoomMutation = { __typename?: 'Mutation', isValidPasscodeForRoom: boolean };

export type NotifyMembersAboutPatientMutationVariables = Types.Exact<{
  input: Types.NotifyMembersAboutPatientInput;
}>;


export type NotifyMembersAboutPatientMutation = { __typename?: 'Mutation', notifyMembersAboutPatient: boolean };

export type DeletePersonalRoomMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeletePersonalRoomMutation = { __typename?: 'Mutation', deletePersonalRoom: boolean };

export type GetRoomForPatientQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type GetRoomForPatientQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomForPatient?: { __typename?: 'RoomForPatient', id: string, legacyId: number, slug: string, name: string, displayName?: string | null, isPersonal: boolean, usePasscode: boolean, usePasscodeStoredValue?: boolean | null, shouldRedirect?: boolean | null, redirectUrl?: string | null, checkInPhotoCapture: boolean, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, roomAdmin: { __typename?: 'OgRoomAdmin', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null, userProfilePictureUrl?: string | null, subscriptionType: Types.UserSubscriptionType, authId?: string | null }, owner?: { __typename?: 'RoomOwnerForPatient', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null, userProfilePictureUrl?: string | null, subscriptionType: Types.UserSubscriptionType, legacyUserId?: string | null } | null } | null } };

export type GetRoomsForTenantQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRoomsForTenantQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomsForTenant: { __typename?: 'RoomsForTenant', members?: Array<{ __typename?: 'RoomMember', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null, userProfilePictureUrl?: string | null }> | null, edges: Array<{ __typename?: 'RoomWithMembersEdge', node: { __typename?: 'RoomWithMembers', roomMemberIds: Array<string>, room: { __typename?: 'Room', id: string, slug: string, isPasscodeEnabled: boolean, membershipType: Types.MembershipType, ownerId?: string | null, sharedRoomDisplayName?: string | null, passcode?: string | null, cameraOff: boolean } } }> } } };


export const GetRoomsForUserDocument = `
    query GetRoomsForUser {
  Room {
    getRoomsForUser {
      edges {
        node {
          id
          membershipType
          slug
          passcode
          isPasscodeEnabled
          sharedRoomDisplayName
          cameraOff
          owner {
            id
            title
            firstName
            lastName
            displayName
          }
        }
      }
    }
  }
}
    `;
export const IsSlugUniqueDocument = `
    query IsSlugUnique($input: SlugInput!) {
  Room {
    isSlugUnique(input: $input)
  }
}
    `;
export const IsSubSlugUniqueDocument = `
    query IsSubSlugUnique($input: SlugInput!) {
  Room {
    isSubSlugUnique(input: $input)
  }
}
    `;
export const UpdateRoomDocument = `
    mutation UpdateRoom($input: RoomUpdateDto!) {
  updateRoom(input: $input) {
    id
    membershipType
    slug
    passcode
    isPasscodeEnabled
    sharedRoomDisplayName
    cameraOff
    ownerId
  }
}
    `;
export const IsValidPasscodeForRoomDocument = `
    mutation IsValidPasscodeForRoom($input: RoomPasscodeInput!) {
  isValidPasscodeForRoom(input: $input)
}
    `;
export const NotifyMembersAboutPatientDocument = `
    mutation NotifyMembersAboutPatient($input: NotifyMembersAboutPatientInput!) {
  notifyMembersAboutPatient(input: $input)
}
    `;
export const DeletePersonalRoomDocument = `
    mutation DeletePersonalRoom {
  deletePersonalRoom
}
    `;
export const GetRoomForPatientDocument = `
    query GetRoomForPatient($input: SlugInput!) {
  Room {
    getRoomForPatient(input: $input) {
      id
      legacyId
      slug
      name
      displayName
      isPersonal
      usePasscode
      usePasscodeStoredValue
      shouldRedirect
      redirectUrl
      checkInPhotoCapture
      isPasscodeEnabled
      sharedRoomDisplayName
      roomAdmin {
        id
        title
        firstName
        lastName
        displayName
        userProfilePictureUrl
        subscriptionType
        authId
      }
      owner {
        id
        title
        firstName
        lastName
        displayName
        userProfilePictureUrl
        subscriptionType
        legacyUserId
      }
    }
  }
}
    `;
export const GetRoomsForTenantDocument = `
    query GetRoomsForTenant {
  Room {
    getRoomsForTenant {
      members {
        id
        title
        firstName
        lastName
        displayName
        userProfilePictureUrl
      }
      edges {
        node {
          room {
            id
            slug
            isPasscodeEnabled
            membershipType
            ownerId
            sharedRoomDisplayName
            passcode
            cameraOff
          }
          roomMemberIds
        }
      }
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    GetRoomsForUser: build.query<GetRoomsForUserQuery, GetRoomsForUserQueryVariables | void>({
      query: (variables) => ({ document: GetRoomsForUserDocument, variables })
    }),
    IsSlugUnique: build.query<IsSlugUniqueQuery, IsSlugUniqueQueryVariables>({
      query: (variables) => ({ document: IsSlugUniqueDocument, variables })
    }),
    IsSubSlugUnique: build.query<IsSubSlugUniqueQuery, IsSubSlugUniqueQueryVariables>({
      query: (variables) => ({ document: IsSubSlugUniqueDocument, variables })
    }),
    UpdateRoom: build.mutation<UpdateRoomMutation, UpdateRoomMutationVariables>({
      query: (variables) => ({ document: UpdateRoomDocument, variables })
    }),
    IsValidPasscodeForRoom: build.mutation<IsValidPasscodeForRoomMutation, IsValidPasscodeForRoomMutationVariables>({
      query: (variables) => ({ document: IsValidPasscodeForRoomDocument, variables })
    }),
    NotifyMembersAboutPatient: build.mutation<NotifyMembersAboutPatientMutation, NotifyMembersAboutPatientMutationVariables>({
      query: (variables) => ({ document: NotifyMembersAboutPatientDocument, variables })
    }),
    DeletePersonalRoom: build.mutation<DeletePersonalRoomMutation, DeletePersonalRoomMutationVariables | void>({
      query: (variables) => ({ document: DeletePersonalRoomDocument, variables })
    }),
    GetRoomForPatient: build.query<GetRoomForPatientQuery, GetRoomForPatientQueryVariables>({
      query: (variables) => ({ document: GetRoomForPatientDocument, variables })
    }),
    GetRoomsForTenant: build.query<GetRoomsForTenantQuery, GetRoomsForTenantQueryVariables | void>({
      query: (variables) => ({ document: GetRoomsForTenantDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetRoomsForUserQuery, useLazyGetRoomsForUserQuery, useIsSlugUniqueQuery, useLazyIsSlugUniqueQuery, useIsSubSlugUniqueQuery, useLazyIsSubSlugUniqueQuery, useUpdateRoomMutation, useIsValidPasscodeForRoomMutation, useNotifyMembersAboutPatientMutation, useDeletePersonalRoomMutation, useGetRoomForPatientQuery, useLazyGetRoomForPatientQuery, useGetRoomsForTenantQuery, useLazyGetRoomsForTenantQuery } = injectedRtkApi;

